// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#bdIframe{margin:10px 22px 30px 22px;overflow:scroll}#BLAST-description{width:1000px;height:50px;margin:15px auto;text-align:center;font-size:25px;color:#407338;font-weight:700}", ""]);
// Exports
module.exports = exports;
